module.exports = __webpack_public_path__ + "img/logo-2.d7f52b57.webp";